import PendingAttachmentApprovals from './PendingAttachmentApprovals';

export default PendingAttachmentApprovals;
